


































































































import { Action, State } from "vuex-class";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { duration } from "@/helpers";
import moment from "moment";
import { firestore } from "@/configs/firebase";
import { getUserId } from "@/helpers";
import * as api from "@/lib/api";
import logger from "@/configs/logger";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import CallBuffer from "@/components/Call/CallBuffer.vue";
import TransferCall from "@/components/Call/TransferCall.vue";
import { User } from "@/types";

@Component({ components: { LeadPanel, TransferCall, CallBuffer } })
export default class ActiveCallCard extends Vue {
  @Action("disconnectDevice") disconnectDevice!: Function;
  @Action("changeInAdminCall") changeInAdminCall!: Function;
  @Action("changeCallMode") changeCallMode!: Function;
  @State("inAdminCallMode") inAdminCallMode!: boolean;
  @State("inCallMode") calling!: boolean;
  @State("user") user!: User;

  @Prop({ default: {}, required: true }) agent!: any;
  @Prop({ required: true }) call!: any;
  @Prop() agents!: User[];

  @Watch("calling")
  onCallModeChange(val: any, preVal: any) {
    this.leadDialog = false;
  }

  duration: string = "";
  timerRef: any = null;
  leadDialog: boolean = false;
  task: any = null;

  beforeDestroy() {
    if (this.timerRef) {
      window.clearInterval(this.timerRef);
    }
  }

  @Watch("call")
  onActiveCallChange(val: any, prevVal: any) {
    window.clearInterval(this.timerRef);
    if (this.call) {
      this.timerRef = window.setInterval(
        () => this.getCallDuration(this.call.created_ts.seconds),
        1000
      );
    }
  }

  get transferOptions() {
    if (!Array.isArray(this.agents)) return [];
    const options = this.agents
      .filter(agent => agent.available && agent.email !== this.user.email)
      .map(agent => `agent:${agent.email}`);
    const availableForTransfer = Array.from(new Set(options));
    logger("log", "transfer opritons:", availableForTransfer);
    return availableForTransfer;
  }

  get leadId() {
    return this.call ? this.call.lead_key.split("/")[1] : "";
  }

  getCallDuration(sec: number): void {
    const start = moment.unix(sec);
    const end = moment.unix(firestore.Timestamp.now().seconds);
    const secs = end.diff(start, "seconds");
    this.duration = duration(secs);
  }

  async handleAdminDisconnect() {
    this.changeInAdminCall(false);
    logger("log", "Disconnecting device for override");
    this.disconnectDevice();
  }

  async handleAdminJoinCall(mode: string, call = this.call) {
    try {
      logger("log", "Admin joining call " + mode);
      await api.adminJoinCall(mode, `task_attribute/${call.id}`);
      logger("log", "Admin successfully joined call");
      this.changeInAdminCall(true);
    } catch (err) {
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Admin joining call failed").goAway(2000);
      }
    }
  }
}
